export const PER_PAGE_OPTIONS = [10, 25,50, 100];
export const DEFAULT_PER_PAGE = 25;
export const enum SortDir {
  ASC = "asc",
  DESC = "desc",
}